module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('Dialog', {
    style: ({
      width: '35vw'
    }),
    attrs: {
      "visible": _vm.printDialog,
      "header": "Do you want to print this bill?",
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.printDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": "Yes"
    },
    on: {
      "click": _vm.printBill
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-danger",
    attrs: {
      "label": "No"
    },
    on: {
      "click": _vm.closePrintDialog
    }
  })], 1)])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '60vw'
    }),
    attrs: {
      "header": "Latest Last Rate",
      "modal": true,
      "visible": _vm.salesRateDetails,
      "closable": true,
      "contentStyle": {
        'overflow': 'scroll'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.salesRateDetails = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": _vm.closeSalesRatesLatest
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('DataTable', {
    staticClass: "editable-cells-table",
    attrs: {
      "value": _vm.latestSalesRateList
    }
  }, [_c('Column', {
    attrs: {
      "header": "Date",
      "field": "nepaliDate"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bill No",
      "field": "billNo"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "voucher",
      "field": "voucher"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Quantity",
      "field": "outQuantity"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Rate",
      "field": "price"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Varients Details",
      "modal": true,
      "visible": _vm.displayVarientsDialog,
      "closable": true,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayVarientsDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('DataTable', {
    ref: "po",
    staticClass: "editable-cells-table",
    attrs: {
      "value": _vm.variantDetailslist,
      "editMode": "cell"
    }
  }, [_c('Column', {
    attrs: {
      "field": "propertyValue",
      "header": "Name",
      "filterMatchMode": "contains"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Pur Qty",
      "field": "quantity"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Avl Qty",
      "field": "avlQuantity"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Sales Qty",
      "field": "salesQuantity"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          attrs: {
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('Button', {
    staticClass: "p-button-danger",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeBasicBatchDetails.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-lg-6 p-xl-2"
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "tran",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  }) : _c('InputMask', {
    ref: "tran",
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "id": "purchaseSalesDate"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-6 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "billNo"
    }
  }, [_vm._v("Invoice No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "billNo",
      "disabled": ""
    },
    model: {
      value: (_vm.billNo),
      callback: function($$v) {
        _vm.billNo = $$v
      },
      expression: "billNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-10 p-lg-2"
  }, [_c('label', {
    attrs: {
      "for": "paymentType"
    }
  }, [_vm._v("Sales Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxType),
      expression: "taxType"
    }],
    staticClass: "selectBox",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.taxType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Sales Type")]), _vm._v(" "), _vm._l((_vm.taxTypeList), function(tax, ind) {
    return _c('option', {
      key: ind
    }, [_vm._v(_vm._s(tax.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "loadFrom"
    }
  }, [_vm._v("Load From ")]), _vm._v(" "), _c('div', {
    staticClass: "radiobox"
  }, [_c('div', {
    staticClass: "radiobox-itm"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loadType),
      expression: "loadType"
    }],
    attrs: {
      "type": "radio",
      "name": "order",
      "value": "order"
    },
    domProps: {
      "checked": _vm._q(_vm.loadType, "order")
    },
    on: {
      "change": [function($event) {
        _vm.loadType = "order"
      }, function($event) {
        return _vm.loadFrom(_vm.loadType)
      }]
    }
  }), _vm._v("Order\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loadType),
      expression: "loadType"
    }],
    attrs: {
      "type": "radio",
      "name": "challan",
      "value": "challan"
    },
    domProps: {
      "checked": _vm._q(_vm.loadType, "challan")
    },
    on: {
      "change": [function($event) {
        _vm.loadType = "challan"
      }, function($event) {
        return _vm.loadFrom(_vm.loadType)
      }]
    }
  }), _vm._v("Challan\n              ")])])])]), _vm._v(" "), (_vm.loadFromOrder && !this.editing) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-3"
  }, [(_vm.loadFromOrder && !this.editing) ? _c('label', {
    attrs: {
      "for": "OrderList"
    }
  }, [_vm._v(" Order List")]) : _vm._e(), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.orderIdList,
      "optionLabel": "orderNoAndAccountName",
      "filter": true,
      "placeholder": "Select Order"
    },
    on: {
      "change": function($event) {
        return _vm.loadSalesOrderDataWithOrderNo(_vm.orderId.orderNo)
      }
    },
    model: {
      value: (_vm.orderId),
      callback: function($$v) {
        _vm.orderId = $$v
      },
      expression: "orderId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loadFromChallan && !this.editing) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-3"
  }, [(_vm.loadFromChallan && !this.editing) ? _c('label', {
    attrs: {
      "for": "ChallanList"
    }
  }, [_vm._v(" Challan List")]) : _vm._e(), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.challanIdList,
      "optionLabel": "orderNoAndAccountName",
      "filter": true,
      "placeholder": "Select Chalan"
    },
    on: {
      "change": function($event) {
        return _vm.loadSalesOrderDataWithChallanNo(_vm.challanId.challanNo)
      }
    },
    model: {
      value: (_vm.challanId),
      callback: function($$v) {
        _vm.challanId = $$v
      },
      expression: "challanId"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-10 p-lg-3"
  }, [_c('label', [_vm._v("Sale To")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.supplierAndCustomerList,
      "filter": true,
      "optionLabel": "nameWithContact",
      "placeholder": "Select Account",
      "showClear": true
    },
    on: {
      "change": _vm.getCreditLimitAmount
    },
    model: {
      value: (_vm.accountMaster),
      callback: function($$v) {
        _vm.accountMaster = $$v
      },
      expression: "accountMaster"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-2 p-lg-4 p-xl-1 align-self-end"
  }, [_c('customerDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Customer'),
      expression: "'Add Customer'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_customer_master": _vm.set_customer_master
    }
  })], 1), _vm._v(" "), (_vm.ifCash) ? _c('div', {
    staticClass: "p-field p-col-10 p-lg-3"
  }, [_c('label', [_vm._v("Customer")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.customerAccountList,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select customer",
      "showClear": true
    },
    model: {
      value: (_vm.customer),
      callback: function($$v) {
        _vm.customer = $$v
      },
      expression: "customer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ifCash) ? _c('div', {
    staticClass: "p-field p-col-2 p-lg-4 p-xl-1 align-self-end"
  }, [_c('customerDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Customer'),
      expression: "'Add Customer'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_customer_master": _vm.set_customer_master
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountMaster.id > 0),
      expression: "accountMaster.id > 0"
    }],
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [(_vm.accountMaster.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Tax No: ")]), _vm._v(" "), _c('b', {
    staticClass: "p-ml-1"
  }, [_vm._v(_vm._s(_vm.accountMaster.panNo))])]) : _vm._e(), _vm._v(" "), (_vm.accountMaster.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Balance: ")]), _vm._v(" "), (_vm.accountMaster.closingBalance > 0) ? _c('b', {
    staticClass: "p-ml-4",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n              " + _vm._s((_vm.accountMaster.closingBalance).toFixed(2) + 'Cr') + "\n            ")]) : _c('b', {
    staticClass: "p-ml-4",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n              " + _vm._s((_vm.accountMaster.closingBalance * (-1)).toFixed(2) + 'Dr') + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-10 p-lg-2"
  }, [_c('label', {
    attrs: {
      "for": "warehouse"
    }
  }, [_vm._v("Store")]), _vm._v(" "), (!_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "filter": true,
      "optionLabel": "name",
      "placeholder": "Select Warehouse",
      "showClear": true
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "filter": true,
      "optionLabel": "name",
      "placeholder": "Select Warehouse",
      "disabled": true
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-1 align-self-end"
  }, [_c('warehouseDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Warehouse'),
      expression: "'Add Warehouse'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_data_warehouse": _vm.set_data_warehouse
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-10 p-lg-1"
  }, [_c('label', {
    attrs: {
      "for": "warehouse"
    }
  }, [_vm._v("Credit Days")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "credit"
    },
    model: {
      value: (_vm.creditDays),
      callback: function($$v) {
        _vm.creditDays = $$v
      },
      expression: "creditDays"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-10 p-lg-8 p-xl-3"
  }, [_vm._m(0), _vm._v(" "), (!_vm.loadItemFromPurchase) ? _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "suggestions": _vm.filteredItems,
      "filterType": "contains",
      "field": "name"
    },
    on: {
      "complete": function($event) {
        return _vm.searchItem($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(slotProps) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px !important"
          }
        }, [_vm._v(_vm._s(slotProps.item.name) + " - " + _vm._s(slotProps.item.itemCode))])]
      }
    }], null, false, 3882569604),
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  }) : _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "suggestions": _vm.filterPurchase,
      "field": "itemToDisplayName"
    },
    on: {
      "complete": function($event) {
        return _vm.searchPurchaseItem($event)
      }
    },
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-2 p-lg-4 p-xl-1 align-self-end"
  }, [_c('itemDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Item'),
      expression: "'Add Item'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5",
    on: {
      "set_data_item": _vm.set_data_item
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "qty"
    }
  }, [_vm._v("Sales Qty")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "minmaxfraction",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), (!_vm.item.multiUnit) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "qty"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('InputText', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.item.unitName),
      callback: function($$v) {
        _vm.$set(_vm.item, "unitName", $$v)
      },
      expression: "item.unitName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.multiUnit) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "unit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.item.itemMultiUnitDetailsDTOList,
      "optionLabel": "unitTo",
      "filter": true,
      "placeholder": "Select One",
      "id": "unit"
    },
    model: {
      value: (_vm.alternateUnit),
      callback: function($$v) {
        _vm.alternateUnit = $$v
      },
      expression: "alternateUnit"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.multiUnit) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "unit"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-rounded p-button-secondary",
    attrs: {
      "label": "Detail"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openConversionDialog(_vm.unitConversion)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('UniConversionDetail', {
    ref: "conversionDialog"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "rate"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "rate",
      "mode": "decimal",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  })], 1), _vm._v(" "), (this.$store.getters.modules.includes('5.39')) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "commissionPerItem"
    }
  }, [_vm._v("Commission")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "commissionPerItem",
      "mode": "decimal",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.commissionPerItem),
      callback: function($$v) {
        _vm.commissionPerItem = $$v
      },
      expression: "commissionPerItem"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "total"
    }
  }, [_vm._v("Total")]), _vm._v(" "), (_vm.$store.state.organisationid != 17) ? _c('InputNumber', {
    attrs: {
      "disabled": "",
      "id": "minmaxfraction",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  }) : _c('InputNumber', {
    attrs: {
      "id": "minmaxfraction",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    on: {
      "change": _vm.findRate
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), (_vm.enableVarients) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-2 align-self-center"
  }, [_c('div', {
    staticClass: "radiobox"
  }, [_c('div', {
    staticClass: "radiobox-itm"
  }, [_c('Checkbox', {
    attrs: {
      "id": "city2",
      "name": "city",
      "binary": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchItemVariantDetails.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.displayVarientsDetails),
      callback: function($$v) {
        _vm.displayVarientsDetails = $$v
      },
      expression: "displayVarientsDetails"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "city2"
    }
  }, [_vm._v("Varients Details")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-2 p-lg-4 p-xl-1 align-self-end"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": !_vm.editDto ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItemToDTOList.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.editDto) ? _c('div', {
    staticClass: "p-field p-col-2 p-lg-4 p-xl-1 align-self-end"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": _vm.itemDTOreset
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.totalAmount))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.setRateFromItem))])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-8"
  }, [(_vm.item.id > 0) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-align-center h-100"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4 mb-0"
  }, [_c('label', {
    attrs: {
      "for": "avl"
    }
  }, [_vm._v("Cur. Stock:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.closingStock))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-2 p-xl-2 align-self-center"
  }, [_c('div', {
    staticClass: "radiobox"
  }, [_c('div', {
    staticClass: "radiobox-itm"
  }, [_c('Checkbox', {
    attrs: {
      "id": "city1",
      "name": "city",
      "binary": true
    },
    on: {
      "click": _vm.searchSalesLatestRate
    },
    model: {
      value: (_vm.salesRateDetails),
      callback: function($$v) {
        _vm.salesRateDetails = $$v
      },
      expression: "salesRateDetails"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "city1"
    }
  }, [_vm._v("Prev Details")])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-4"
  })]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '75vw',
      height: '20vw'
    }),
    attrs: {
      "header": "Do you want to select normal customer or regular customer?",
      "visible": _vm.customerType,
      "modal": true,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.customerType = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-danger",
          attrs: {
            "label": "No",
            "icon": "pi pi-times"
          },
          on: {
            "click": _vm.closeBasic
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-success",
          attrs: {
            "label": "Yes",
            "icon": "pi pi-check",
            "autofocus": ""
          },
          on: {
            "click": _vm.closeBasic
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12 genTable"
  }, [_c('div', {
    staticClass: "p-datatable-responsive p-datatable-gridlines"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Item Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Hs Code")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), (this.$store.getters.modules.includes('5.39')) ? _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Commission")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.inventoryInOutDetailList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemMaster.itemNameWithCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemMaster.hsCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemMaster.unitName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rate))]), _vm._v(" "), (_vm.$store.getters.modules.includes('5.39')) ? _c('td', [_vm._v(_vm._s(item.commissionPerItem))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s((item.rate * item.quantity).toFixed(4)))]), _vm._v(" "), _c('td', [_c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          return _vm.editItemDTO(item, index)
        }
      }
    }), _vm._v(" "), (_vm.editDto) ? _c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-danger",
      attrs: {
        "icon": "pi pi-trash",
        "disabled": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeItemFromDTO(item, index)
        }
      }
    }) : (!_vm.editDto) ? _c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.removeItemFromDTO(item, index)
        }
      }
    }) : _vm._e()], 1)])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Total:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalQty))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subTotal.toFixed(4)))]), _vm._v(" "), _c('td', [_vm._v(" ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-xl-4"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "rows": "6"
    },
    model: {
      value: (_vm.narration),
      callback: function($$v) {
        _vm.narration = $$v
      },
      expression: "narration"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-4"
  }, [_c('label', {
    attrs: {
      "for": "soldBy"
    }
  }, [_vm._v("Sold By:")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "soldBy",
      "options": _vm.users,
      "optionLabel": "name",
      "optionValue": "id",
      "placeholder": "Select Sold By"
    },
    model: {
      value: (_vm.soldByID),
      callback: function($$v) {
        _vm.soldByID = $$v
      },
      expression: "soldByID"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-4"
  }, [_c('label', {
    attrs: {
      "for": "exclude"
    }
  }, [_vm._v("Exclude In Report:")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "exclude",
      "binary": true
    },
    model: {
      value: (_vm.exclude),
      callback: function($$v) {
        _vm.exclude = $$v
      },
      expression: "exclude"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-2 mt-25"
  }, [_c('Button', {
    staticClass: "p-button-warning",
    attrs: {
      "icon": "pi pi-refresh",
      "label": "Reset"
    },
    on: {
      "click": _vm.reset
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-2 mt-25"
  }, [_c('form', [_c('Button', {
    staticClass: "p-button p-button-success addNewBtn btn-btm-0 width-auto",
    attrs: {
      "label": "Extra Expenses",
      "icon": "pi pi-plus"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '60vw'
    }),
    attrs: {
      "header": "Extra Expenses",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'auto'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-save",
            "label": "Save"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasic.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasic.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-9 p-lg-6 p-xl-3"
  }, [_c('label', {
    attrs: {
      "for": "extraExpense"
    }
  }, [_vm._v("Extra Expenses Name")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.extraExpensesList,
      "optionLabel": "expensesName",
      "filter": true,
      "placeholder": "Select One",
      "id": "extraExpense",
      "showClear": true
    },
    model: {
      value: (_vm.extraExpenses),
      callback: function($$v) {
        _vm.extraExpenses = $$v
      },
      expression: "extraExpenses"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3 p-lg-2 p-xl-2"
  }, [_c('extraExpensesDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Extra Expenses'),
      expression: "'Add Extra Expenses'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "extraExpensesAmt"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "extraExpensesAmt"
    },
    model: {
      value: (_vm.extraExpenseAmt),
      callback: function($$v) {
        _vm.extraExpenseAmt = $$v
      },
      expression: "extraExpenseAmt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-xl-2"
  }, [_c('div', {
    staticClass: "radiobox"
  }, [_c('div', {
    staticClass: "radiobox-itm"
  }, [_c('label', {
    attrs: {
      "for": "applyVat"
    }
  }, [_vm._v("Apply Vat")]), _vm._v(" "), _c('InputSwitch', {
    model: {
      value: (_vm.applyVat),
      callback: function($$v) {
        _vm.applyVat = $$v
      },
      expression: "applyVat"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('label', {
    attrs: {
      "for": "applyVat"
    }
  }, [_vm._v("Apply On Bill")]), _vm._v(" "), _c('InputSwitch', {
    model: {
      value: (_vm.applyExpensesOnBill),
      callback: function($$v) {
        _vm.applyExpensesOnBill = $$v
      },
      expression: "applyExpensesOnBill"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-offset-7 p-col-5 p-lg-offset-0 p-lg-3"
  }, [_c('div', {
    staticClass: "p-fluid p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-field p-col-6 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-info btn-btm-0 width-auto p-button",
    attrs: {
      "label": !_vm.editExtraExpenses ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addExtraExpensesToList.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.editExtraExpenses) ? _c('div', {
    staticClass: "p-field p-col-6 p-mt-5"
  }, [(_vm.editExtraExpenses) ? _c('Button', {
    staticClass: "p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelExtraExpenses.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-datatable-responsive p-datatable-gridlines finalCalc"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("S.N")]), _vm._v(" "), _c('th', [_vm._v("Expenses Name")]), _vm._v(" "), _c('th', [_vm._v("Apply Vat")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.inventoryExtraExpensesList), function(expense, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.extraExpense.expensesName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.extraExpense.applyVat ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.extraExpenseAmt))]), _vm._v(" "), _c('td', [_c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editExtraExpensesDto(expense, index)
        }
      }
    }), _vm._v(" "), (_vm.editExtraExpenses) ? _c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-danger",
      attrs: {
        "icon": "pi pi-trash",
        "disabled": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeExtraExpense(expense, index)
        }
      }
    }) : _c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeExtraExpense(expense, index)
        }
      }
    })], 1)])])
  })], 2)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-9 p-xl-4"
  }, [_c('div', {
    staticClass: "p-datatable-responsive p-datatable-gridlines finalCalc"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Subtotal")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subTotal.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Discount")]), _vm._v(" "), _c('th', [(_vm.chooseDiscountPer) ? _c('Button', {
    attrs: {
      "label": "%"
    },
    on: {
      "click": _vm.chooseDisPercent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chooseDiscountAmt) ? _c('Button', {
    attrs: {
      "label": "RS"
    },
    on: {
      "click": _vm.chooseDisountAmt
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.chooseDiscountPer) ? _c('InputText', {
    model: {
      value: (_vm.discountPer),
      callback: function($$v) {
        _vm.discountPer = $$v
      },
      expression: "discountPer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chooseDiscountAmt) ? _c('InputText', {
    model: {
      value: (_vm.discountAmt),
      callback: function($$v) {
        _vm.discountAmt = $$v
      },
      expression: "discountAmt"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.chooseDiscountPer) ? _c('tr', [_c('th', [_vm._v("Discounted Amt:")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.discountAmt))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Taxable")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.taxable.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Non-taxable")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.nonTaxable.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Tax")]), _vm._v(" "), _c('th', [_vm._v("13%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tax.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalBillAmount.toFixed(4)))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-6 p-md-4 p-xl-2 p-xl-offset-6"
  }, [_c('Button', {
    staticClass: "p-button-success",
    attrs: {
      "icon": "pi pi-save",
      "label": _vm.salesInvoice === undefined ? 'Save' : 'Update'
    },
    on: {
      "click": _vm.addSalesInvoice
    }
  })], 1), _vm._v(" "), (_vm.salesInvoice != undefined) ? _c('div', {
    staticClass: "p-field p-col-6 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-6 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-info",
    attrs: {
      "label": " Print",
      "icon": "pi pi-print"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-6 p-md-4 p-xl-2"
  }, [_c('Button', {
    staticClass: "p-button-secondary",
    attrs: {
      "icon": "pi pi-download",
      "label": "Generate PDF"
    },
    on: {
      "click": _vm.printBill
    }
  })], 1)])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "itm"
    }
  }, [_vm._v("Item"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b36aa98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/sales/salesinvoice.vue
// module id = 2162
// module chunks = 0